module.exports = __webpack_public_path__ + "img/Flag_of_Tuvalu.096e1716.svg";